import React, { Component } from "react";
import CloseIcon from "../../../img/close.svg"

import ConstantTempIcon from "../../../img/constant-temp-icon.svg"
import CyclingTempIcon from "../../../img/cycling-temp-icon.svg"
import FinalTempIcon from "../../../img/final-temp-icon.svg"

export class ChooseType extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  close = (type) => {
    this.props.setDialogDisplay({
      id: this.props.id,
      displayDialog: false
    })
  }

  addThermocyclerStep = (type) => {
    this.props.addSequence({
      id: this.props.id,
      index: this.props.sequence.length,
      type: type
    })
    this.props.setInnerSection({
      id: this.props.id,
      innerSection: "STEP_EDIT"
    });
    this.props.setEditConnection({
      id: this.props.id,
      editConnection: this.props.sequence.length
    })
    this.props.setDialogDisplay({
      id: this.props.id,
      displayDialog: false
    })
  }

  render() {
    return (
      <div className="wrapper">
        <div
          aria-label="Close Button"
          tabIndex={0}
          className={"close"}
          onKeyDown={e => {
            if (e.keyCode === 13 || e.keyCode === 32) this.close(e);
          }}
          onClick={this.close}
        >
          <p>
            Close{" "}
            <img
              style={{
                display: "inline-block",
                top: "3px",
                position: "relative"
              }}
              src={CloseIcon}
              alt="Close button"
            />
          </p>
        </div>
        <h3>Choose one of the following to add:</h3>
        <div className="button-row">
          <button className="primary" onClick={()=>this.addThermocyclerStep("constant")}>
            <div className="icon-wrap">
              <img src={ConstantTempIcon} alt="Constant temparature step icon."/>
            </div>
            Constant temperature step
          </button>
          <button className="secondary" onClick={()=>this.addThermocyclerStep("cycling")}>
            <div className="icon-wrap">
              <img src={CyclingTempIcon} alt="Cycling temparature step icon."/>
            </div>
            Cycling temperatures
          </button>
          <button className="tertiary" onClick={()=>this.addThermocyclerStep("final")}>
            <div className="icon-wrap">
              <img src={FinalTempIcon} alt="Final temparature step icon."/>
            </div>
            Final temperature
          </button>
        </div>
      </div>
    )
  }
}
